<template>
  <custom-callout class="mt-2">
    <div class="row">
      <div class="col-md-12 col-sm-12 pl-5">
        <div class="divider-horizontal">
          <div class="row">
            <div class="col-md-3 col-sm-12 pt-0">
              <div class="regular">
                PEI:
              </div>
              <div class="regular text-black">
                <h5>{{ item.peiId }}</h5>
              </div>
            </div>
            <div class="col-md-3 col-sm-12 pt-0">
              <div class="regular">
                Fecha de Firma:
              </div>
              <div class="regular text-black">
                <h5>{{ formatDate(item.generalClosedDate) }}</h5>
              </div>
            </div>
            <div class="col-md-3 col-sm-12 col-12 pt-0">
              <div class="regular">
                Fecha Inicio Servicio Actual:
              </div>
              <div class="regular text-black">
                <h5>{{ formatDate(item.serviceAnalysisPlacementStartDate) }}</h5>
              </div>
            </div>
            <div class="col-md-3 col-sm-12 pt-0">
              <div class="regular">
                Fecha Inicio Servicio Corregida:
              </div>
              <div class="regular text-black">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="'date-' + item.peiId"
                  rules=""
                >
                  <custom-date-picker
                    v-model="item.serviceAnalysisPlacementStartDateEdited"
                    :custom-error-msg="'Fecha requerida.'"
                    :open-date="openDate"
                    :min-date="dateLimits.academicDateFromLimit"
                    :max-date="dateLimits.academicDateToLimit"
                    :error="errors[0]"
                    placeholder="DD/MM/YYYY"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from '@/components/common/CustomCallout';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import moment from "moment/moment";

export default {
  name: 'Row',
  components: {
    CustomCallout,
    CustomDatePicker,
  },
  props: {
    item: {
      type: Object,
      default: () => ({
        peiId: '',
        studentSieId: '',
        serviceAnalysisPlacementStartDate: '',
        generalClosedDate: '',
      }),
    },
    dateLimits: {
      type: Object,
      default: () => ({
        academicDateFromLimit: null,
        academicDateToLimit: null,
      }),
    }
  },
  data: () => ({}),
  methods: {
    formatDate(date) {
      if (date == null) return '';

      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
  },
  computed: {
    openDate() {
      const today = new Date();
      return this.dateLimits.academicDateFromLimit <= today && today <= this.dateLimits.academicDateToLimit
        ? today
        : this.dateLimits.academicDateFromLimit;
    }
  }
};
</script>

<style scoped>
.icon-position {
  max-width: 6%;
  padding-top: 35px;
  text-align: center;
}
.force-orange {
  color: #ff7058;
}
.text-gray-l {
  color: #3f5b60;
}
.text-gray {
  color: #727272;
}
.text-black {
  color: #11291b;
}
.divider-horizontal {
  border-right: 1px solid #e2e2e2;
}
.col-3-alt {
  max-width: 20%;
}
.shadow-icon {
  color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 50px;
  width: 34px;
}
</style>
